import { render, staticRenderFns } from "./clockDetail.vue?vue&type=template&id=b4ec28a4&"
import script from "./clockDetail.vue?vue&type=script&lang=js&"
export * from "./clockDetail.vue?vue&type=script&lang=js&"
import style0 from "./clockDetail.vue?vue&type=style&index=0&id=b4ec28a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports